import { render, staticRenderFns } from "./ConfirmTransferApproval.vue?vue&type=template&id=3ec26449&"
import script from "./ConfirmTransferApproval.vue?vue&type=script&lang=js&"
export * from "./ConfirmTransferApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports